const Footer = () => {
  const d = new Date();
  let year = d.getFullYear();
  return <div className="float-left">
    
      <p className='text-[#c71003]   text-[24px] '> @ {year} India </p>
      <p className='text-[#03C6C7] font-bold text-2xl ' > Developed By: Deepesh Kumar </p>
   
  </div>;
};

export default Footer;
